import type { LucideIcon } from "lucide-react";
import {
  BookOpen,
  Building2,
  ClipboardList,
  Fingerprint,
  Boxes,
  KeyRound,
  LayoutDashboard,
  Layers,
  ShieldCheck,
  SlidersHorizontal,
  Upload,
  Users,
} from "lucide-react";

export type Phase = "ERFASSEN" | "VERSTEHEN" | "BEWERTEN" | "OPTIMIEREN" | "NACHWEISEN";
export const PHASES: Phase[] = ["ERFASSEN", "VERSTEHEN", "BEWERTEN", "OPTIMIEREN", "NACHWEISEN"];
export const PHASE_LABEL: Record<Phase, string> = {
  ERFASSEN: "Erfassen", VERSTEHEN: "Verstehen", BEWERTEN: "Bewerten",
  OPTIMIEREN: "Optimieren", NACHWEISEN: "Nachweisen",
};

export interface NavItem {
  route: string;
  label: string;
  phase: Phase | "übergreifend";
  icon: LucideIcon;
  question: string;
  ready: boolean; // im aktuellen Stand ausgebaut?
}

export const NAV: NavItem[] = [
  { route: "/", label: "Cockpit", phase: "übergreifend", icon: LayoutDashboard, ready: true, question: "Wo stehen wir — Vertrag gegen Bedarf, über alle elf Landschaften?" },
  { route: "/import", label: "Daten", phase: "ERFASSEN", icon: Upload, ready: true, question: "Woher kommen die Daten — und was fehlt noch?" },
  { route: "/personen", label: "Personen", phase: "VERSTEHEN", icon: Users, ready: true, question: "Wer ist überhaupt eine Person?" },
  { route: "/berechtigungen", label: "Nachweis", phase: "VERSTEHEN", icon: KeyRound, ready: true, question: "Woher kommt die Einstufung — und was wurde tatsächlich genutzt?" },
  { route: "/rollen", label: "Rollen", phase: "VERSTEHEN", icon: Boxes, ready: true, question: "Welche Rolle trägt welchen Wert — und wer trägt sie?" },
  { route: "/landschaften", label: "Landschaften", phase: "BEWERTEN", icon: Layers, ready: true, question: "Wie verteilt sich das — und wann wird es je Landschaft ernst?" },
  { route: "/vertrag", label: "Vertrag", phase: "BEWERTEN", icon: Building2, ready: true, question: "Stimmt die Zahl, auf der unser Vertrag steht?" },
  { route: "/optimierung", label: "Optimierung", phase: "OPTIMIEREN", icon: SlidersHorizontal, ready: true, question: "Was tun wir — und was dürfen wir tatsächlich anfassen?" },
  { route: "/plan", label: "Plan", phase: "OPTIMIEREN", icon: ClipboardList, ready: true, question: "Was setzen wir um — und wer bekommt welche Rolle?" },
  { route: "/gates", label: "Cutover-Gates", phase: "NACHWEISEN", icon: ShieldCheck, ready: true, question: "Wie beweisen wir Compliance an jedem Go-Live?" },
  { route: "/einstellungen", label: "Einstellungen", phase: "NACHWEISEN", icon: Fingerprint, ready: true, question: "Verhältnistabelle, Preis, Identitätsschlüssel — die Stellschrauben." },
  { route: "/methodik", label: "Methodik & Grenzen", phase: "übergreifend", icon: BookOpen, ready: true, question: "Welches Regelwerk liegt zugrunde — und was deckt das Werkzeug bewusst nicht ab?" },
];

export const navByRoute = (r: string) => NAV.find((n) => n.route === r);
